import React, { useState, useEffect } from 'react';

const SuperannuationYearsFilter = ({ selectedYears, onChange }) => {
  const [localYears, setLocalYears] = useState(selectedYears || '');

  useEffect(() => {
    setLocalYears(selectedYears || '');
  }, [selectedYears]);

  const handleSliderChange = (value) => {
    setLocalYears(value);
    onChange(value);
  };

  const handleInputChange = (value) => {
    // Ensure value is within bounds
    const numValue = Math.max(0, Math.min(50, parseInt(value) || 0));
    setLocalYears(numValue);
    onChange(numValue);
  };

  const handleQuickSelect = (years) => {
    setLocalYears(years);
    onChange(years);
  };

  const clearFilter = () => {
    setLocalYears('');
    onChange('');
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Superannuation within (years)
        </label>
        {localYears !== '' && (
          <button
            onClick={clearFilter}
            className="text-xs text-blue-600 hover:text-blue-800 underline"
          >
            Clear
          </button>
        )}
      </div>

      <div className="text-xs text-gray-500">
        Show employees retiring in ≤ X years
      </div>

      {localYears !== '' && (
        <div className="text-sm text-gray-700 font-medium text-center bg-blue-50 py-2 rounded">
          Retiring within {localYears} {localYears === 1 ? 'year' : 'years'}
        </div>
      )}
      
      <div className="space-y-3">
        {/* Slider */}
        <div>
          <label className="block text-xs text-gray-500 mb-2">
            Years: {localYears !== '' ? localYears : 'Not set'}
          </label>
          <input
            type="range"
            min={0}
            max={20}
            value={localYears || 0}
            onChange={(e) => handleSliderChange(parseInt(e.target.value))}
            className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
          <div className="flex justify-between text-xs text-gray-400 mt-1">
            <span>0</span>
            <span>10</span>
            <span>20</span>
          </div>
        </div>

        {/* Quick Select Buttons */}
        <div className="flex flex-wrap gap-1">
          <button
            onClick={() => handleQuickSelect(1)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              localYears === 1 
                ? 'bg-blue-100 text-blue-800' 
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            1 Year
          </button>
          <button
            onClick={() => handleQuickSelect(3)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              localYears === 3 
                ? 'bg-blue-100 text-blue-800' 
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            3 Years
          </button>
          <button
            onClick={() => handleQuickSelect(5)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              localYears === 5 
                ? 'bg-blue-100 text-blue-800' 
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            5 Years
          </button>
          <button
            onClick={() => handleQuickSelect(10)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              localYears === 10 
                ? 'bg-blue-100 text-blue-800' 
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            10 Years
          </button>
        </div>

        {/* Manual Input */}
        <div className="space-y-1">
          <label className="block text-xs text-gray-500">Manual input (0-50 years)</label>
          <input
            value={localYears}
            onChange={(e) => handleInputChange(e.target.value)}
            type="number"
            min="0"
            max="50"
            placeholder="Enter years"
            className="w-full border border-gray-300 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

// Example usage component
const SuperannuationFilter = ({selectedYears, setSelectedYears}) => {

  return (
    <div className="max-w-md mx-auto p-4">
      <SuperannuationYearsFilter
        selectedYears={selectedYears}
        onChange={setSelectedYears}
      />
      
      {/* Demo display */}
      <div className="mt-6 p-3 bg-gray-50 rounded">
        <h3 className="text-sm font-medium mb-2">Current Filter:</h3>
        <p className="text-sm text-gray-600">
          {selectedYears !== '' 
            ? `Show employees retiring within ${selectedYears} ${selectedYears === 1 ? 'year' : 'years'}`
            : 'No superannuation filter applied'
          }
        </p>
      </div>
    </div>
  );
};

export default SuperannuationFilter;